import { useCallback } from "react";

import { InputColor } from "@/components/ui/input/input-color";

import { FormErrorMessage, FormItem, FormLabel } from "../../../_base/form";

type InputColorFieldProps = {
	value: string | undefined | null;
	handleChange: (e: string) => void;

	className?: string;

	errorMessage?: string;
	label?: string;
};

const InputColorField = ({
	value = undefined,
	handleChange,
	className = "",
	errorMessage,
	label,
}: InputColorFieldProps) => {
	const onChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const { value } = e.currentTarget;
			handleChange(value);
		},
		[handleChange],
	);

	return (
		<FormItem className={className}>
			<FormLabel>{label}</FormLabel>
			<InputColor onChange={onChange} value={value ?? undefined} />
			<FormErrorMessage>{errorMessage}</FormErrorMessage>
		</FormItem>
	);
};

InputColorField.displayName = "InputColorField";

export { InputColorField };
